import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient} from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';
import ImageWithLoader2 from './components/ImageWithLoader2';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';


function Home() {

  const { menu, toggleMobileMenu } = useAppLayout();
    
  const [members, setMembers] = useState([]);

  const loggedFamilyAdmin = localStorage.getItem("family_admin");
 
  const sliderRef = useRef(null);

  const queryClient = useQueryClient(); 

  const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const { data: coverImageData, isLoadingC, isErrorC, isFetchingC } = useQuery({
      queryKey: ['coverImage'],
      queryFn: () =>
        axios.get(`${API_URL}/family-cover-home-api`, { withCredentials: true })
          .then(res => res.data),
      staleTime: 0, 
      cacheTime: Infinity,
    }); 
    
    const coverImage = coverImageData?.image
      ? `${API_URL}/images/${coverImageData.image}`
      : null;


//upload cover
const [coverModalOpen, setCoverModalOpen] = useState(false);
const [eventModalOpen, setEventModalOpen] = useState(false);

const [file, setFile] = useState(null);
const [fileName, setFileName] = useState('');


const [isCompressing, setIsCompressing] = useState(false);
const [isUploading, setIsUploading] = useState(false);


const handleFileChange = async (e) => {
const file = e.target.files[0];
if (!file) return;

try {
  const options = {
    maxSizeMB: 1,             // Compress to ~1MB
    maxWidthOrHeight: 800,    // Resize to a maximum of 800px (width/height)
    useWebWorker: true,       // Faster compression
  };

  // Compress the selected file
  const compressedFile = await imageCompression(file, options);

  // Save the compressed file and keep the original name for display
  setFile(compressedFile);
  setFileName(file.name);

} catch (err) {
  console.error('Image compression error:', err);
  toast.error('Failed to compress image.');
}
};


const handleUploadCover = async () => {
if (!file) {
  toast.error("Please select an image first", { position: "top-right", autoClose: 3000 });
  return;
}

setIsCompressing(true); // Start compression indicator

try {
  // Compress to ~200KB max
  const targetKB = 100;
  let quality = 0.9;
  let compressedFile = file;

  while (true) {
    const options = {
      maxSizeMB: targetKB / 1024,
      initialQuality: quality,
      useWebWorker: true,
    };

    compressedFile = await imageCompression(file, options);

    if (compressedFile.size / 1024 <= targetKB || quality <= 0.1) break;
    quality -= 0.1;
  }

  setIsCompressing(false);
  setIsUploading(true);

  const formData = new FormData();
  formData.append('image_name', compressedFile);

  await axios.post(`${API_URL}/family-cover-home-update-api`, formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  toast.success("Upload successful", { position: "top-right", autoClose: 3000 });
  queryClient.invalidateQueries(['coverImage']);
  setCoverModalOpen(false);
  setFileName('');
} catch (err) {
  toast.error("Upload failed", { position: "top-right", autoClose: 3000 });
  console.error("Upload error:", err);
} finally {
  setIsUploading(false);
  setIsCompressing(false);
}
};

//end upload cover

//use image
const handleUseCoverImage = async (imageName) => {
try {
  await axios.put(`${API_URL}/family-cover-home-update-from-gallery`, 
    { image_name: imageName }, 
    {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' }
    }
  );

  toast.success("Cover image updated from gallery", { position: "top-right", autoClose: 3000 });
  queryClient.invalidateQueries(['coverImage']); // Refresh
  setCoverModalOpen(false);
  setEventModalOpen(false); // Close modal
} catch (error) {
  console.error("Error updating cover from gallery:", error);
  toast.error("Failed to update cover image", { position: "top-right", autoClose: 3000 });
}
};

//end use image

//profile uploaded images
const { data: gallery, isLoading: isLoadingImg, isError: isErrorImg, refetch } = useQuery({
queryKey: ['uploadedGallery'],
queryFn: async () => {
  const response = await axios.get(`${API_URL}/family-cover-uploaded-images-api`, {
    withCredentials: true
  });
  if (response.data.Status === "Success") {
    return response.data.images;
  } else {
    throw new Error('Failed to fetch gallery images');
  }
},
staleTime: 0,
cacheTime: Infinity,
});
//end profile uploaded images


const { data: membersData, isLoadingF, isErrorF, isFetchingF } = useQuery({
  queryKey: ['familyMembers'],
  queryFn: () =>
    axios
      .get(`${API_URL}/family-members-home`, { withCredentials: true })
      .then(res => res.data),
  staleTime: 0, 
  cacheTime: Infinity,
});

const [currentIndex, setCurrentIndex] = useState(0);

useEffect(() => {
  if (membersData) {
    setMembers(membersData);
  }
}, [membersData]);

useEffect(() => {
  if (!members.length) return;

  const interval = setInterval(() => {
    setCurrentIndex((prevIndex) => {
      const nextIndex = prevIndex + 2;
      return nextIndex >= members.length ? 0 : nextIndex;
    });
  }, 10000);

  return () => clearInterval(interval);
}, [members]);




const { data: memberStats = { total: 0, males: 0, females: 0 }, isLoading, isError, error } = useQuery({
  queryKey: ['memberStats'],
  queryFn: () =>
      axios.get(`${API_URL}/number-of-family-members-home-api`, { withCredentials: true })
      .then(res => res.data),
  staleTime: 0,
  cacheTime: Infinity,
  });



const { data: familyDescription, isLoading: loadingDesc, isError: errorDesc } = useQuery({
  queryKey: ['familyDescription'],
  queryFn: () =>
    axios.get(`${API_URL}/family-history-home-api`, { withCredentials: true }).then(res => res.data),
  staleTime: 0, // Cache for 5 minutes
  cacheTime: Infinity,
});

const { data: clanData, isLoadingCl, isErrorCl } = useQuery({
  queryKey: ['clanData'],
  queryFn: () => axios.get(`${API_URL}/clan-home-api`).then(res => res.data),
  staleTime: 0,
  cacheTime: Infinity,
});

const { data: totemData, isLoading: isLoadingT, isError: isErrorT } = useQuery({
  queryKey: ['totemData'],
  queryFn: () => axios.get(`${API_URL}/totem-home-api`).then(res => res.data),
  staleTime: 0,
  cacheTime: Infinity,
});



  const moveToIndex = (index) => {
      setCurrentIndex(index);
  };

  //update clan description

  const [isClanModalOpen, setIsClanModalOpen] = useState(false);
const [editClanDesc, setEditClanDesc] = useState("");
const [editDescId, setEditDescId] = useState(null);
const [isUpdating, setIsUpdating] = useState(false);

const openClanDescriptionModal = (description, id) => {
  setEditClanDesc(description || "");
  setEditDescId(id);
  setIsClanModalOpen(true);
};

const handleUpdateClanDescription = () => {
  if (!editClanDesc.trim()) {
    toast.error("Description cannot be empty");
    return;
  }

  setIsUpdating(true);

  axios
    .put(
      `${API_URL}/update-clan-description-settings-api/${editDescId}`,
      { description: editClanDesc },
      { withCredentials: true }
    )
    .then(() => {
      toast.success("Clan description updated");
      setIsClanModalOpen(false);
      queryClient.invalidateQueries(["clanData"]); // Refresh clanData
    })
    .catch((err) => {
      console.error("Update failed", err);
      toast.error("Failed to update clan description");
    })
    .finally(() => {
      setIsUpdating(false);
    });
};


//gallery

const { data: familyGallery, isLoadingFGallery, isErrorFGallery } = useQuery({
  queryKey: ['familyGallery'],
  queryFn: async () => {
    const res = await axios.get(`${API_URL}/family-gallery-images-api`, {
      withCredentials: true,
    });

    if (res.data.Status === 'Success') return res.data.images;
    throw new Error('Failed to fetch gallery images');
  },
  staleTime: 0,
  cacheTime: Infinity,
});


//posts

 const { data: posts = [], isLoadingPosts } = useQuery({
    queryKey: ["homePostsPreview"],
    queryFn: async () => {
      try {
        const res = await axios.get(`${API_URL}/get-status-posts-api`, {
          withCredentials: true,
          params: { limit: 3, offset: 0 },
        });

        // expect: { success: true, data: [...] }
        if (res.data?.success && Array.isArray(res.data.data)) {
          return res.data.data;
        }
        return [];
      } catch (err) {
        console.error("homePostsPreview error:", err);
        return []; // swallow error → no red text
      }
    },
    staleTime: 30_000,
    retry: false,
  });


  const { data: treeExpired, isLoadingExpiry } = useQuery({
    queryKey: ["userExpiryDetails"],
    queryFn: () =>
      axios.get(`${API_URL}/user-payment-details-home-api`, { withCredentials: true })
        .then((res) => res.data),
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
  
  let status = "loading";
  let daysLeft = 0;
  let pct = 0;
  
  if (!isLoadingExpiry && treeExpired) {
    status = treeExpired.status;
    daysLeft = treeExpired.days_left;
  
    // If expired, force zero
    if (status === "expired") {
      pct = 0;
    } else {
      const totalDays = status === "trial" ? 30 : treeExpired.total_days || daysLeft;
      pct = Math.min((daysLeft / totalDays) * 100, 100);
    }
  }



  //get events
      const { data, isLoadingEvents, isErrorEvents } = useQuery({
        queryKey: ['familyEvents'],
        queryFn: () =>
          axios.get(`${API_URL}/family-events-list-api`, { withCredentials: true })
            .then((response) => {
              if (response.data.Status === "Success") {
                return response.data.Data;
              } else {
                throw new Error('Failed to fetch events');
              }
            }),
        staleTime: 0,
        cacheTime: Infinity,
      });
  
      const todayEvents = data?.filter(event => {
        const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
        return event.event_date === today;
      });


      const formatDateLong = (dateStr) => {
        const date = new Date(dateStr);
      
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
      
        const getOrdinalSup = (n) => {
          if (n > 3 && n < 21) return 'th';
          switch (n % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
          }
        };
      
        const ordinal = getOrdinalSup(day);
      
        return (
          <>
            {day}
            <sup>{ordinal}</sup> {month}, {year}
          </>
        );
      };
   
    return (
            <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />

                <div className="page-wrapper">
                    <div className="content container-fluid">


                      {/* family cover */}

                  <div className='row'>
                      <div className='col-12 col-md-12'>

                      <div className="mb-4 position-relative px-2">
                    <div className="hero-cover-card rounded-4 overflow-hidden shadow-lg">
                      {coverImageData?.image ? (

                            <ImageWithLoader2
                            src={`${API_URL}/images/${coverImageData.image}`} alt="Family Cover"
                            placeholder="https://oret.africa/tree/img/imageplaceholder-icon.jpg"
                            style={{ height: '220px', width: '100%', objectFit: 'cover' }}
                            fadeDuration={800}
                              blurAmount={15}   
                              className="cover-img"
                            />
                        
                      ) : (
                        <div className="cover-fallback d-flex align-items-center justify-content-center">
                          <i className="fas fa-camera fa-2x text-white opacity-75" />
                        </div>
                      )}
      
                      {/* subtle tint for readability like profile-style hero */}
                      <div className="cover-gradient-overlay" />
      
                      {/* overlay text bottom-left */}
                      <div className="cover-welcome-text">
                        <h2 className="mb-1">Welcome Home</h2>
                        <p className="mb-0 opacity-90">Your family's gathering place</p>
                      </div>
      
                      {/* edit button – same corner vibe as Profile cover */}
                      {loggedFamilyAdmin === '1' && (
                        <button
                          onClick={() => setCoverModalOpen(true)}
                          className="cover-edit-btn btn btn-brand btn-sm d-inline-flex align-items-center justify-content-center"
                          type="button"
                          title="Change cover"
                          aria-label="Change cover"
                        >
                          <i className="fas fa-camera" />
                          <span className="d-none d-sm-inline ms-1">Cover</span>
                        </button>
                      )}
                    </div>
                  </div>

                  

<ReactModal
  isOpen={coverModalOpen}
  onRequestClose={() => setCoverModalOpen(false)}
  className="Modal"
  overlayClassName="Overlay"
>
  <div className="modal-header" style={{ padding: "10px 12px" }}>
    <div className="d-flex align-items-center gap-2">
      <span
        className="d-inline-flex align-items-center justify-content-center"
        style={{
          width: 28,
          height: 28,
          borderRadius: 10,
          background: "rgba(117,180,55,.12)",
          border: "1px solid rgba(117,180,55,.22)",
          color: "#184A2C",
          fontWeight: 900,
          fontSize: 12,
        }}
      >
        <i className="fas fa-camera" />
      </span>

      <h6 className="mb-0" style={{ fontWeight: 900, color: "#184A2C" }}>
        Update cover
      </h6>
    </div>

    <button
      type="button"
      className="btn-close modalCloseButton"
      onClick={() => setCoverModalOpen(false)}
      style={{ transform: "scale(.9)" }}
    ></button>
  </div>

  <div className="modal-body" style={{ padding: "12px" }}>
    {/* Selected file (compact) */}
    <div
      className="d-flex align-items-center justify-content-between gap-2 mb-2"
      style={{
        background: "rgba(117,180,55,.06)",
        border: "1px solid rgba(117,180,55,.18)",
        borderRadius: 12,
        padding: "8px 10px",
      }}
    >
      <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: 999,
            background: fileName ? "#75B437" : "#9ca3af",
            flexShrink: 0,
          }}
        />
        <span className="small" style={{ color: "#111827" }}>
          {fileName ? "Selected:" : "No file"}
        </span>

        {fileName && (
          <span
            className="small"
            title={fileName}
            style={{
              fontWeight: 800,
              color: "#111827",
              maxWidth: 170,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "inline-block",
            }}
          >
            {fileName}
          </span>
        )}
      </div>

      {(isCompressing || isUploading) && (
        <span className="small text-muted">
          <i className="fas fa-spinner fa-spin" />
        </span>
      )}
    </div>

    {/* Buttons (compact) */}
    <label
      htmlFor="imageUpload"
      className="btn w-100 d-flex align-items-center justify-content-center gap-2 mb-2"
      style={{
        borderRadius: 12,
        border: "1px solid rgba(117,180,55,.35)",
        background: "#fff",
        color: "#184A2C",
        fontWeight: 900,
        padding: ".55rem .75rem",
      }}
    >
      <i className="fa fa-upload" />
      Choose image
    </label>

    <input
      type="file"
      id="imageUpload"
      name="image"
      required
      onChange={handleFileChange}
      style={{ display: "none" }}
      accept="image/*"
    />

    <button
      onClick={handleUploadCover}
      className="btn w-100 d-flex align-items-center justify-content-center gap-2 mb-2"
      disabled={isCompressing || isUploading}
      style={{
        borderRadius: 12,
        fontWeight: 900,
        padding: ".55rem .75rem",
        backgroundImage: "linear-gradient(135deg, #75B437, #184A2C)",
        border: "none",
        color: "#fff",
      }}
    >
      {(isCompressing || isUploading) ? (
        <>
          <i className="fas fa-spinner fa-spin" />
          Updating…
        </>
      ) : (
        <>
          <i className="fas fa-check-circle" />
          Update
        </>
      )}
    </button>

    <button
      type="button"
      onClick={() => setEventModalOpen(true)}
      className="btn w-100 d-flex align-items-center justify-content-center gap-2"
      style={{
        borderRadius: 12,
        border: "1px dashed rgba(24,74,44,.28)",
        background: "rgba(24,74,44,.06)",
        color: "#184A2C",
        fontWeight: 900,
        padding: ".55rem .75rem",
      }}
    >
      <i className="fas fa-images" />
      From uploads
    </button>
  </div>

  <div className="modal-footer" style={{ padding: "10px 12px" }}>
    <button
      type="button"
      className="btn btn-outline-secondary"
      style={{ borderRadius: 12, fontWeight: 800, padding: ".45rem .75rem" }}
      onClick={() => setCoverModalOpen(false)}
    >
      Close
    </button>
  </div>
</ReactModal>


        

   <ReactModal isOpen={eventModalOpen} onRequestClose={() => setEventModalOpen(false)} 
        className="Modal modal-lg" overlayClassName="Overlay"
      >
        <div className="modal-header">
          <h5 className="modal-title">Uploaded Images</h5>
          <button type="button" className="btn-close modalCloseButton" onClick={() => setEventModalOpen(false)}></button>
        </div>

        <div className="modal-body" style={{height: '460px', overflowY: 'auto'}}>

        <div className="row" >


        {gallery && gallery.length > 0 ? (
                        gallery.map((image) => (
                          <div className='col-6 col-md-4' key={image.id} style={{ textAlign: "center", marginBottom: '2%' }}>

                            <img 
                              src={`${API_URL}/images/${image.image_name}`} 
                              alt={image.description} 
                              style={{ width: '100%', height: '250px', objectFit: 'cover', marginBottom: '1%' }}
                            />

                            <button
                              className="btn btn-sm btn-outline-primary1 mt-1"
                              onClick={() => handleUseCoverImage(image.image_name)}
                            >
                              Use Image
                            </button>

                          </div>
                        ))
                      ) : (
                        <p>No gallery images found.</p>
                      )}
          
          </div>
        </div>

        <div className="modal-footer">
          
        </div>
      </ReactModal> 




                      </div>
                  </div>


      
      <div className="row">
            <div className="col-md-12">
      
            <div className="members-section card soft-radius border-0 shadow-sm mb-3">
                    <div className="card-body py-3">
                      <div className="section-header d-flex justify-content-between align-items-center mb-3">
                        <div className="section-title-wrapper">
                          <h6 className="section-title mb-0">
                            <i className="fas fa-users-crown me-2 text-primary"></i>
                            Recent Family Members
                          </h6>
                        </div>
                          <Link to="/family-members" className="view-all-btn text-decoration-none">
                            <span className="view-all-icon" aria-hidden="true">
                              <i className="fas fa-angle-right"></i>
                            </span>
                          </Link>
                      </div>
      
                      <div className="members-scroll-container d-flex gap-4 flex-nowrap overflow-auto pb-2 no-scrollbar">
                        
      
        {Array.isArray(membersData) && membersData.length > 0 ? (
        < >
          {membersData.map((member) => {
            const fullName = `${member.n_prefix || ''} ${member.name || ''} ${member.last_name || ''}`;
            const imagePath = `${API_URL}/images/${member.image_name}`;
      
              return (
                <Link
                  key={member.id}
                  to="/profile"
                  state={{ memberId: member.id }}
                  className="member-card text-center text-decoration-none"
                  aria-label={`View ${fullName || "member"} profile`}
                >
        
                            <div className="member-avatar-wrapper">
                                    <div className="member-avatar-ring">
                                      <div className="member-avatar-inner">
      
                      <ImageWithLoader2
                        src={imagePath}
                        placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                        alt={member.name}
                        className="members_card_image"
                        style={{ width: 70, height: 70, objectFit: 'cover' }}
                      />
      
                </div>
                </div>
                <div className="member-status-dot"></div>
                </div>
                
                <div className="member-name mt-2">{fullName}</div>
                  
                  
                </Link>
              );
            })}
        </>
      ) : isLoadingF ? (
        <p>Loading members...</p>
      ) : isErrorF ? (
        <p>Error loading members.</p>
      ) : (
        <p>No members found.</p>
      )}
      
       
      
      
                      </div>
                    </div>
                  </div>
      
          </div>
          </div> 



    <div className="row">
      <div className="col-md-12">

          <div className="shortcut-nav-container card soft-radius border-0 shadow-sm mb-3 px-2">
                      <div className="card-body p-2">
                        <div className="shortcut-nav-grid">

                          <Link to="/chat-list" className="shortcut-item">
                            <div className="shortcut-icon chat">
                              <i className="fas fa-comments" />
                            </div>
                            <span className="shortcut-label">Chat</span>
                          </Link>
        
                          <Link to="/family-posts" className="shortcut-item">
                            <div className="shortcut-icon posts">
                              <i className="fas fa-newspaper" />
                            </div>
                            <span className="shortcut-label">Posts</span>
                          </Link>
        
                          <Link to="/family-tree" className="shortcut-item">
                            <div className="shortcut-icon tree">
                              <i className="fas fa-sitemap" />
                            </div>
                            <span className="shortcut-label">Tree</span>
                          </Link>
        
                          <Link to="/gallery" className="shortcut-item">
                            <div className="shortcut-icon gallery">
                              <i className="fas fa-images" />
                            </div>
                            <span className="shortcut-label">Gallery</span>
                          </Link>
        
                          <Link to="/family-members" className="shortcut-item">
                            <div className="shortcut-icon members">
                              <i className="fas fa-users" />
                            </div>
                            <span className="shortcut-label">Members</span>
                          </Link>
        
                          <Link to="/timeline" className="shortcut-item">
                            <div className="shortcut-icon timeline">
                              <i className="fas fa-clock-rotate-left" />
                            </div>
                            <span className="shortcut-label">Timeline</span>
                          </Link>
                        </div>
                      </div>
                    </div>
        

        </div>
</div>        
                        

 
  
                       

<div class="row">
    <div className="col-md-12">
    <div className="card soft-radius border-0 shadow-sm mb-3 home-card gallery-card">
      <div className="card-body p-3">
        {/* header */}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div className="d-flex align-items-center gap-2">
            <span className="chip chip-rose">
              <i className="fas fa-images" />
            </span>
            <div>
              <h6 className="fw-bold mb-0 small-title">Family gallery</h6>
              <div className="text-muted extra-small d-none d-sm-block">
                A snapshot of recent memories.
              </div>
            </div>
          </div>
          <Link
            to="/gallery"
            className="view-all-btn text-decoration-none"
          >
            <span className="view-all-icon" aria-hidden="true">
              <i className="fas fa-angle-right"></i>
            </span>
          </Link>
        </div>

        
        {isLoading ? (
                <div className="loadingspinnerDiv">
                <div className="loadingspinner"></div>
              </div>
              ) : isError ? (
                <p className="text-danger text-center mt-3">Failed to load gallery.</p>
              ) : familyGallery && familyGallery.length > 0 ? (
                
                <div className=" row ">

                {familyGallery.map((image) => (
                  <div className="col-4 col-md-4 " key={image.id} style={{ textAlign: "center" }}>
                    
                    <ImageWithLoader2
                      src={`${API_URL}/images/${image.image_name}`}
                      placeholder="https://oret.africa/tree/img/imageplaceholder-icon.jpg"
                      alt={image.description || "Gallery image"}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "8px"
                      }}
                    />

                  </div>
                ))}

                </div>

              ) : (
                <div className="d-flex align-items-center gap-2 small text-muted mt-1">
                  <i className="fas fa-camera text-muted" />
                  <span>No photos yet. Add memories to your gallery.</span>
                </div>
              )}

      </div>
    </div>

</div>
 </div>   



 <div class="row ">
 <div className="col-md-12 ">

  <div className='card soft-radius border-0 shadow-sm mb-2'>
  <div className='card-body p-2'>

  

 <div className="d-flex align-items-center gap-2 mb-2">
        <span className="chip chip-green">
          <i className="fas fa-gift" />
        </span>
        <h6 className="fw-bold mb-0">Today</h6>
      </div>



  <div className="list-group today-list">

  {isErrorEvents && (
  <div className="alert alert-danger">
    Failed to load events.
  </div>
)}

{todayEvents?.length === 0 && (
  <p className="text-muted small text-center">No events today.</p>
)}

{todayEvents?.map(event => (
  <div
    key={event.id}
    className="today-item list-group-item d-flex align-items-center justify-content-between border-0 rounded-3 p-2 mb-2"
  >
    <div className="d-flex align-items-center">
      <span className="avatar-ring me-3">
        <ImageWithLoader2
          src={`${API_URL}/images/${event.saved_by_image}`}
          placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
          fadeDuration={800}
          blurAmount={15}
          className="rounded-circle"
          style={{ width: "35px", height: "35px", objectFit: "cover" }}
        />
      </span>

      <div className="me-2">
        <div className="fw-semibold">
          <i className="fa-solid fa-cake-candles me-2 text-danger"></i>
          {event.event_type} : {formatDateLong(event.event_date)}
        </div>
        <div className="text-muted small">{event.description}</div>
      </div>
    </div>
  </div>
))}


  




         </div>

         </div>
  </div>

         </div>
         </div>


 
 <div class="row">
   <div className="col-md-12">
  
   <div className="card soft-radius border-0 shadow-sm mb-3 home-card posts-card">
        <div className="card-body p-3">
          {/* header */}
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div className="d-flex align-items-center gap-2">
              <span className="chip chip-emerald">
                <i className="fas fa-newspaper" />
              </span>
              <div>
                <h6 className="fw-bold mb-0 small-title">Latest posts</h6>
                <div className="text-muted extra-small d-none d-sm-block">
                  Quick glimpse of what the family is sharing.
                </div>
              </div>
            </div>
           <Link to="/family-posts" className="view-all-btn text-decoration-none">
    <span className="view-all-icon" aria-hidden="true">
      <i className="fas fa-angle-right"></i>
    </span>
  </Link>
  
  
          </div>
  
          {/* body */}
          {isLoadingPosts ? (
            <div className="mt-1">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="posts-item py-2">
                  <div className="posts-skeleton-line" />
                  <div className="posts-skeleton-line small mt-1" />
                </div>
              ))}
            </div>
          ) : !posts.length ? (
            <div className="d-flex align-items-center gap-2 small text-muted mt-1">
              <i className="fas fa-comment-slash text-muted" />
              <span>No posts yet. Start the first conversation!</span>
            </div>
          ) : (
            <div className="posts-swiper-wrap">
              <Swiper
                spaceBetween={16}
                slidesPerView={2.2}
                breakpoints={{
                  576: { slidesPerView: 1.2 },  // mobile
                  768: { slidesPerView: 1.8 }, // tablet
                  992: { slidesPerView: 2.2 }, // desktop (2 + preview of 3rd)
                }}
              >
                {posts.map((post) => {
                  const text = post.status || "";
                  const author =
                    post.user?.name ||
                    post.user?.surname ||
                    post.user?.last_name ||
                    "Unknown";
                  const initial = (author || "U").charAt(0).toUpperCase();
                  const authorImage =
                    post.user?.user_image || post.user?.image_name || post.user?.profile_image || "";
                  const createdAt = post.date_posted
                    ? new Date(post.date_posted).toLocaleString(undefined, {
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "2-digit",
                      })
                    : null;
  
                  return (
                    <SwiperSlide key={post.id}>
                      <Link to="/family-posts" className="posts-slide-link text-decoration-none text-dark">
                        <article className="posts-slide-card">
                          <div className="posts-slide-head">
                            <div className="posts-slide-avatar">
                              {authorImage ? (
                                <img
                                  src={`${API_URL}/images/${authorImage}`}
                                  alt={author}
                                  className="posts-slide-avatar-image"
                                  onError={(e) => {
                                    e.currentTarget.style.display = "none";
                                    const fallback = e.currentTarget.nextElementSibling;
                                    if (fallback) fallback.style.display = "flex";
                                  }}
                                />
                              ) : null}
                              <span
                                className="posts-slide-avatar-fallback"
                                style={{ display: authorImage ? "none" : "flex" }}
                              >
                                {initial}
                              </span>
                            </div>
                            <div className="posts-slide-meta">
                              <div className="posts-slide-author">{author}</div>
                              {createdAt && <div className="posts-slide-time">{createdAt}</div>}
                            </div>
                            <i className="fas fa-ellipsis-h posts-slide-more" />
                          </div>
  
                          <div className="posts-slide-text">
                            {text || "Post with photo"}
                          </div>
  
                          <div className="posts-slide-image">
                            {post.status_image ? (
                              <img
                                src={`${API_URL}/images/${post.status_image}`}
                                alt="post"
                                onError={(e) => {
                                  e.currentTarget.src =
                                    "https://oret.africa/tree/img/imageplaceholder-icon.jpg";
                                }}
                              />
                            ) : (
                              <div className="posts-slide-image-placeholder">
                                <i className="far fa-image" />
                              </div>
                            )}
                          </div>
                        </article>
                      </Link>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          )}
        </div>
      </div>
  
      </div>
      </div>

    


    <div class="row">
    <div className="col-md-12">
    <div className="card soft-radius border-0 shadow-sm records-card">
      <div className="card-body p-3">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center gap-2">
            <span className="records-icon">
              <i className="fas fa-book-open" />
            </span>
            <h6 className="mb-0 records-title">Historical records</h6>
          </div>
          <span className="soon-badge">Coming soon</span>
        </div>

        <p className="records-text small mb-3">
          Search across birth, census, and archive indexes—arriving shortly.
        </p>

        <div className="input-group records-input-group">
          <span className="input-group-text border-end-0 records-input-addon">
            <i className="fas fa-search" />
          </span>
          <input
            className="form-control border-start-0 records-input"
            placeholder="Search names, places, years…"
            disabled
          />
        </div>
      </div>
    </div>


    </div>
    </div>



    {/*<div className="row">
  <div className="col-md-12">
    <div className="card soft-radius border-0 shadow-sm mb-2">
      <div className="card-body p-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <span className="chip chip-amber">
              <i className="fas fa-crown" />
            </span>
            <h6 className="fw-bold mb-0">Your plan</h6>
          </div>

          <span className="badge bg-light text-dark">
              {status === "trial"
                ? `${daysLeft} days left`
                : status === "premium"
                ? "Premium"
                : "Expired"}
            </span>
        </div>

        <div className="mt-2 plan-progress">
          <div className="plan-progress-bar" style={{ width: `${pct}%` }} />
        </div>

        <div className="d-flex justify-content-end mt-2">
          {status === "trial" && (
            <Link to=" " className="btn btn-sm btn-warning rounded-pill">
              Upgrade Now
            </Link>
          )}
          {status === "expired" && (
            <Link to="/family-tree" className="btn btn-sm btn-outline-danger rounded-pill">
              Renew
            </Link>
          )}
          
        </div>
      </div>
    </div>
  </div>
</div>*/}



                    </div>
                </div>



                <style>{`
        :root {
          --brand: #75B437;
          --brand-dark: #3b6a1f;
          --brand-rgb: 117,180,55;
        }

        .btn-brand {
          background: var(--brand);
          color: #fff !important;
          border: 0;
        }
        .btn-brand:hover { filter: brightness(.95); }

        .content { 
          padding: 0; 
          background-color: #EBF4ED;
          min-height: 100vh;
        }
        .home-page .page-wrapper{
          padding-bottom: calc(58px + env(safe-area-inset-bottom, 0px));
        }

        .soft-radius { border-radius: 1px !important; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        .no-scrollbar::-webkit-scrollbar { display: none; }

        /* Hero Cover – same vibe as Profile */
        .hero-cover-card {
          height: 220px;
          position: relative;
          background: var(--brand-dark);
        }
        .cover-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        .cover-fallback {
          width: 100%;
          height: 100%;
          background: var(--brand-dark);
        }
        .cover-gradient-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.28);
          z-index: 1;
        }
        .cover-welcome-text {
          position: absolute;
          bottom: 22px;
          left: 28px;
          color: #fff;
          z-index: 2;
        }
        .cover-welcome-text h2 {
          font-size: 1.5rem;
          font-weight: 800;
          margin: 0;
          text-shadow: 0 3px 10px rgba(0,0,0,0.6);
        }
        .cover-welcome-text p {
          font-size: .95rem;
          margin: 0;
          text-shadow: 0 1px 4px rgba(0,0,0,0.6);
        }

       .cover-edit-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  top: auto;
  z-index: 3;

  border-radius: 999px;
  padding: 4px 10px;       /* smaller */
  font-size: 0.75rem;      /* smaller text */
  line-height: 1;
  box-shadow: 0 10px 25px rgba(0,0,0,0.35);
  min-height: 34px;        /* compact height */
}


        @media (hover: hover) {
          .cover-edit-btn:hover {
            transform: translateY(-1px);
            box-shadow: 0 14px 40px rgba(0,0,0,0.55);
          }
        }
        .cover-edit-btn:active {
          transform: scale(.96);
          transition: transform .1s;
        }

        /* Members row */
        .view-all-btn{
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 24px;
          min-width: 24px;
          padding: 0;
          border-radius: 999px;
          background: #fff;
          border: 1.5px solid #75B437;
          color: #184A2C !important;
          box-shadow: 0 1px 4px rgba(24,74,44,.10);
          transition: transform .18s ease, box-shadow .18s ease;
        }
        .view-all-icon{
          display: inline-flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
        }
        .view-all-icon i{ font-size: 11px; }
        @media (hover: hover){
          .view-all-btn:hover{
            transform: translateY(-1px);
            box-shadow: 0 3px 8px rgba(24,74,44,.18);
          }
        }
        .view-all-btn:active{
          transform: scale(.96);
          box-shadow: 0 1px 4px rgba(24,74,44,.10);
        }

        /* Activity card */
        .activity-card{
          background: #ffffff;
          color: #0f172a;
          border-radius: 14px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 4px 12px rgba(15,23,42,.06);
          border-top: 3px solid #75B437;
        }
        .activity-icon{
          width: 28px;
          height: 28px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          background: #f1f5f9;
          color: #0f172a;
        }
        .activity-metrics{
          display:grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          margin-top: 6px;
        }
        .activity-metric{
          background: #f8fafc;
          border-radius: 12px;
          padding: 10px 12px;
          border: 1px solid #e5e7eb;
        }
        .activity-metric-value{
          font-weight: 700;
          font-size: 1rem;
          display:flex;
          align-items:center;
          color: #184A2C;
        }
        .activity-metric-label{
          font-size: .72rem;
          letter-spacing: .2px;
          color: #75B437;
        }
        .activity-divider{
          height: 1px;
          background: #e5e7eb;
          margin: 10px 0 8px;
        }
        .activity-tip{
          font-size: .8rem;
          color: #475569;
          display:flex;
          align-items:center;
        }

        .members-scroll-container { scroll-snap-type: x mandatory; padding: 8px 0; }
        .member-card { animation: fadeInUp .6s ease-out both; cursor:pointer; transition:all .3s cubic-bezier(.4,0,.2,1); }
        @media (hover: hover){ .member-card:hover{ transform: translateY(-4px) scale(1.02); } .member-card:hover .member-avatar-ring{ box-shadow:0 8px 20px rgba(34,197,94,.4); transform:scale(1.05);} }
        .member-card:active{ transform:scale(.95); transition:transform .1s; }

        .member-avatar-wrapper{ position:relative; display:inline-block; }
        .member-avatar-ring{ background-color:#75B437; padding:3px; border-radius:50%; display:inline-flex; box-shadow:0 4px 12px rgba(117,180,55,.3); transition:all .3s ease; }
        .member-avatar-inner{ background:#fff; padding:2px; border-radius:50%; display:inline-flex; }
        .member-avatar-inner img{ border-radius:50%; display:block; }
        .member-status-dot{ position:absolute; bottom:4px; right:4px; width:16px; height:16px; background:#75B437; border:2px solid #fff; border-radius:50%; box-shadow:0 2px 4px rgba(0,0,0,.1); }

        .member-name{ font-size:.875rem; font-weight:600; color:#000; max-width:90px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }

        /* Loading */
        .member-card-loading{ text-align:center; }
        .member-avatar-loading, .member-name-loading{ background:#EBF4ED; border-radius:50%; position:relative; overflow:hidden; }
        .member-avatar-loading{ width:76px; height:76px; }
        .member-name-loading{ width:60px; height:16px; margin:0 auto; border-radius:8px; }
        .loading-shimmer{ position:absolute; top:0; left:-100%; width:100%; height:100%; background:linear-gradient(90deg, transparent, rgba(255,255,255,.8), transparent); animation:shimmer 1.5s infinite; }
        @keyframes shimmer{ 0%{left:-100%;} 100%{left:100%;} }

        /* Empty */
        .empty-members-state{ text-align:center; padding:40px 20px; color:#184A2C; width:100%; }
        .empty-members-state .btn-outline-primary{ border-color:#75B437; color:#184A2C; }
        @media (hover: hover){ .empty-members-state .btn-outline-primary:hover{ background-color:#75B437; border-color:#75B437; color:#fff; } }

        /* Sections spacing */
        .home-sections-container > * { margin-bottom: 16px; }
        .home-end-space {
          margin-top: 0 !important;
          height: 0 !important;
        }

        @media (max-width: 768px) {
          .cover-welcome-text h2 { font-size: 1.25rem; }
          .cover-welcome-text p { font-size: 0.85rem; }
        }

        @keyframes fadeInUp{ from{opacity:0; transform:translateY(20px);} to{opacity:1; transform:translateY(0);} }

        /* ===== SHORTCUT NAV STYLES ===== */
        .shortcut-nav-container { background: #ffffff; }

        .shortcut-nav-grid {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          gap: 8px;
        }

        @media (max-width: 768px) {
          .shortcut-nav-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;
          }
        }

        .shortcut-item {
        
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          padding: 12px 8px;
          text-decoration: none;
          border-radius: 12px;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          background: transparent;
          color: #184A2C;
          font-size: 0.8rem;
        }

        .shortcut-label {
          font-size: 0.8rem;
          font-weight: 500;
        }

        @media (hover: hover) {
          .shortcut-item:hover {
            background: #F4F9F5;
            transform: translateY(-2px);
          }

          .shortcut-item:hover .shortcut-icon {
            transform: scale(1.08);
            box-shadow: 0 6px 16px rgba(117, 180, 55, 0.25);
          }
        }

        .shortcut-item:active {
          transform: scale(0.96);
          transition: transform 0.1s;
        }

        .shortcut-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: #184A2C;
          background: #F4F9F5;
          border: 2px solid #E8F3EA;
          transition: all 0.25s ease;
          box-shadow: 0 2px 8px rgba(24, 74, 44, 0.08);
        }
      `}</style>


<style>{`
      .soft-radius { border-radius: 12px !important; }
      @keyframes shimmer { 0% { background-position:-450px 0 } 100%{ background-position:450px 0 } }

      /* headers */
      .chip { width:28px; height:28px; border-radius:9999px; color:#fff; display:inline-flex; align-items:center; justify-content:center; }
      .chip-green   { background: #2e7d32; }
      .chip-indigo  { background: #475569; }
      .chip-rose    { background: #8b5e3c; }
      .chip-emerald { background: #2C533D; }
      .chip-amber   { background: #75B437; color:#fff; }

      /* list rows */
      .row-item { display:flex; align-items:center; justify-content:space-between; padding:.5rem 0; border-bottom:1px solid rgba(0,0,0,.06); }
      .row-item:last-child { border-bottom:0; }
      .row-item:hover { background: rgba(15, 23, 42, 0.02); border-radius: 8px; padding-left:.5rem; padding-right:.5rem; }

      .pill-icon { width:36px; height:36px; border-radius:9999px; background:#f1f5f9; color:#0f172a; display:flex; align-items:center; justify-content:center; }

      .badge-dot { width:10px; height:10px; border-radius:9999px; background:#94a3b8; }
      .badge-dot.duplicate { background:#fb7185; }
      .badge-dot.relationship { background:#22c55e; }
      .badge-dot.hint { background:#06b6d4; }

      /* premium */
      .premium-banner { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:16px; background: #184A2C; border-radius: 12px; }
      .premium-banner img { display:none; }
      @media (min-width:576px){ .premium-banner img { display:block; width:240px; height:140px; object-fit:cover; } }

      /* quick actions */
      .quick-grid { display:grid; grid-template-columns: repeat(4,1fr); gap:.5rem; }
      @media (max-width:576px){ .quick-grid{ grid-template-columns: repeat(2,1fr); } }
      .qa { display:flex; flex-direction:column; align-items:center; justify-content:center; gap:.4rem; padding:.75rem .5rem; border-radius:12px; text-decoration:none; background:#f8fafc; color:#0f172a; }
      .qa i { font-size:18px; }
      .qa:hover { background:#eef2f7; }

      /* admin banner */
      .admin-banner { display:flex; justify-content:space-between; align-items:flex-start; padding:.5rem .75rem; border-radius:12px; }
      .admin-banner .admin-icon { width:28px; height:28px; border-radius:9999px; display:flex; align-items:center; justify-content:center; background:#fff3; color:#fff; }
      .admin-banner.promo { background: #184A2C; color:#fff; }
      .admin-banner.info  { background:#f1f5f9; }

      /* trial plan progress */
      .plan-progress{ height:10px; background:#d9e9dc; border-radius:9999px; overflow:hidden; }
      .plan-progress-bar{ height:100%; background: #75B437; }

      /* Coming soon card */
      .coming-soon-card { position: relative; overflow: hidden; }
      .corner-ribbon{
        position:absolute; top:12px; right:-42px;
        transform: rotate(35deg);
        background:#8B5E3C;
        color:#fff; font-weight:700; font-size:.72rem;
        padding:6px 56px; box-shadow:0 6px 16px rgba(0,0,0,.15);
        letter-spacing:.06em;
      }
      .cs-icon{
        width:28px; height:28px; display:inline-flex; align-items:center; justify-content:center;
        background:#F4E6D8; color:#8B5E3C; border-radius:8px;
      }
      .cs-grid{ display:grid; gap:10px; margin-bottom:10px; }
      @media (min-width: 480px){ .cs-grid{ gap:12px; } }
      .cs-input{
        background:#f6f6f6 !important;
        border:1px dashed #e2e2e2 !important;
        color:#9b9b9b !important;
        pointer-events:none;
      }
      .cs-btn{
        background:#8B5E3C; border-color:#8B5E3C;
        opacity:.85; cursor:not-allowed;
      }
      .cs-chip{
        background:#F4E6D8; color:#8B5E3C; border:1px dashed rgba(139,94,60,.35);
        padding:6px 10px; border-radius:9999px; font-size:.8rem;
        opacity:.7; user-select:none;
      }
      .cs-note{ font-size:.85rem; color:#6b6b6b; }

            /* ----- Historical records: colored card like Premium ----- */
      .records-card {
        background: #f3e8d4;
        color: #4d3b2a;
        position: relative;
        overflow: hidden;
        border: 1px solid #c4b08f;
      }
      .records-card::before { content: none; }
      .records-card .card-body {
        position: relative;
        z-index: 1;
      }

      .records-icon {
        width: 30px;
        height: 30px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        background: #e8dbc2;
        color: #5e6f4d;
        box-shadow: 0 2px 8px rgba(77,59,42,0.12);
      }

      .records-title { font-weight: 700; color: #3f2f21; }

      .records-text { color: #5b4a39; }

      .soon-badge {
        font-size: .72rem;
        font-weight: 700;
        padding: 4px 9px;
        border-radius: 9999px;
        background: #efe5d1;
        color: #5e6f4d;
        border: 1px solid #9cad85;
        text-transform: uppercase;
        letter-spacing: .06em;
      }

      .records-input-group {
        background: #e8dbc2;
        border-radius: 9999px;
        overflow: hidden;
        border: 1px solid #c7b394;
      }
      .records-input-addon {
        background: transparent;
        border: none;
        color: #5e6f4d;
      }
      .records-input {
        background: transparent !important;
        border: none !important;
        color: #5b4a39 !important;
        font-size: .85rem;
        cursor: not-allowed;
      }
      .records-input::placeholder {
        color: #8a7660;
      }






/* Latest posts — thumbnail style, like a shortcut */
.posts-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.posts-image-preview {
  flex-shrink: 0;
  width: 110px;          /* preview width */
  height: 80px;          /* preview height */
  border-radius: 12px;
  overflow: hidden;
  margin-left: 8px;
  background: #e5e7eb;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
}

.posts-image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;      /* neat cropping */
  display: block;
}

.posts-swiper-wrap {
  padding-top: 2px;
}

.posts-slide-link {
  display: block;
}

.posts-slide-card {
  border: 1px solid #e6ece8;
  border-radius: 14px;
  background: #fff;
  padding: 12px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.posts-slide-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.posts-slide-avatar {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
  background: #2C533D;
  flex-shrink: 0;
  overflow: hidden;
}

.posts-slide-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.posts-slide-avatar-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
  background: #2C533D;
}

.posts-slide-meta {
  min-width: 0;
  flex: 1;
}

.posts-slide-author {
  font-weight: 700;
  font-size: 0.95rem;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.posts-slide-time {
  font-size: 0.74rem;
  color: #6b7280;
}

.posts-slide-more {
  color: #6b7280;
  font-size: 0.8rem;
}

.posts-slide-text {
  margin-top: 8px;
  font-size: 0.95rem;
  line-height: 1.35;
  color: #111827;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 0;
}

.posts-slide-image {
  margin-top: 6px;
  border-radius: 10px;
  overflow: hidden;
  background: #eef2f0;
  height: 140px;
}

.posts-slide-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.posts-slide-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 2rem;
}






      /* Compact mode */
      .compact-body { padding: 10px 12px !important; }
      .compact-grid { gap: 6px !important; }
      .compact-input { padding: 5px 7px !important; font-size: 0.8rem !important; }
      .compact-btn { padding: 6px 8px !important; font-size: 0.85rem; }
      .small-title { font-size: 0.9rem; }
      .small-icon { width: 24px; height: 24px; font-size: 0.75rem; }
      .compact-chip { padding: 3px 7px !important; font-size: 0.7rem !important; }
      .compact-note { margin-top: 6px !important; font-size: 0.75rem; line-height: 1.2; }

      .corner-ribbon {
        font-size: 0.6rem !important;
        padding: 4px 40px !important;
      }

      /* tiny type pills for CombinedFeedCard */
      .type-pill{
        padding: 2px 6px;
        border-radius: 9999px;
        font-size: .7rem;
        line-height: 1;
        border: 1px solid transparent;
      }
      .type-pill.activity{
        background: #eef6ff;
        color: #1d4ed8;
        border-color: #bfdbfe;
      }
      .type-pill.news{
        background: #fef3f2;
        color: #b91c1c;
        border-color: #fecaca;
      }

      /* Today card polish */
      .today-list .today-item{
        background: #f8f9fa;
        transition: all .18s ease;
      }
      .today-list .today-item:hover{
        background: #f1f3f5;
        transform: translateY(-1px);
      }

      /* Avatar rings */
      .avatar-ring img{
        width: 44px; height: 44px; object-fit: cover; border-radius: 50%;
        border: 2px solid #22c55e;
        background: #fff;
      }
      .avatar-ring.ring-amber img{ border-color: #f59e0b; }

      /* Tighter buttons on mobile */
      .today-btn{ letter-spacing: .2px; }
      @media (max-width: 390px){
        .today-btn{ padding: 4px 10px !important; }
      }

      .icon-pill {
        width: 32px;
        height: 32px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .last-border-0:last-child {
        border-bottom: 0 !important;
      }

      .text-truncate-2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .gallery-thumb img {
        transition: transform 0.25s ease;
      }

      @media (hover: hover) {
        .gallery-thumb:hover img {
          transform: scale(1.05);
        }
      }

      /* ------- Posts preview styling ------- */
      .posts-card {
        background: #ffffff;
      }
      .posts-list {
        margin: 0;
        padding: 0;
      }
      .posts-item {
        position: relative;
        border-bottom: 1px solid rgba(15, 23, 42, 0.06);
      }
      .posts-item:last-child {
        border-bottom: 0;
      }
      .posts-dot {
        width: 8px;
        height: 8px;
        border-radius: 999px;
        background: #22c55e;
        flex-shrink: 0;
      }
      .posts-meta {
        font-size: 0.75rem;
        color: #6b7280;
      }
      .posts-view-all {
        font-size: 0.8rem;
        white-space: nowrap;
      }
      .posts-skeleton-line {
        height: 10px;
        border-radius: 999px;
        background-image: linear-gradient(90deg, #f3f4f6, #e5e7eb, #f3f4f6);
        background-size: 400px 100%;
        animation: shimmer 1.2s linear infinite;
      }
      .posts-skeleton-line.small {
        width: 60%;
      }

      /* ------- Gallery preview styling ------- */
      .gallery-card {
        background: #ffffff;
      }
      .gallery-preview-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 6px;
      }
      @media (max-width: 576px) {
        .gallery-preview-grid {
          gap: 4px;
        }
      }
      .gallery-preview-tile {
        position: relative;
        overflow: hidden;
        border-radius: 10px;
        background: #e5e7eb;
        
      }
      .gallery-preview-tile.large {
        grid-column: span 2;
        grid-row: span 2;
        padding-top: 100%;
      }
      .gallery-preview-tile img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.25s ease;
      }
      .gallery-preview-tile.skeleton {
        background-image: linear-gradient(90deg, #f3f4f6, #e5e7eb, #f3f4f6);
        background-size: 400px 100%;
        animation: shimmer 1.2s linear infinite;
      }
      @media (hover: hover) {
        .gallery-preview-tile img {
          transform: scale(1.02);
        }
        .gallery-preview-tile:hover img {
          transform: scale(1.07);
        }
      }
      .gallery-more-overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient(
          145deg,
          rgba(0, 0, 0, 0.45),
          rgba(0, 0, 0, 0.25)
        );
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .gallery-more-overlay span {
        color: #ffffff;
        font-weight: 700;
        font-size: 0.9rem;
        padding: 6px 12px;
        border-radius: 999px;
        background: rgba(15, 23, 42, 0.75);
      }

      .extra-small {
        font-size: 0.78rem;
      }
    `}</style>



            </div>
        
    );
}

export default Home;
